export class FeatureFlagConstants {
	public static readonly ModelsExperience = {
		appName: 'model-portfolios',
		viewId: 'models-experience',
		urlPart: 'investment-strategies'
	};
}
